import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';
import { Store } from '@ngrx/store';
// import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Browser } from '@capacitor/browser';

import * as rootReducer from 'app/core/store';
import * as fromActions from 'app/core/store/actions';
import { PlatformService } from 'app/core/services/platform.service';
import { ModalHelpComponent } from '../../modals/modal-help/modal-help.component';
import { ModalsService } from '../../modals/modals.service';

@Component({
  standalone: false,
  selector: 'pptl-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss'],
})
export class PreferencesComponent {
  displayView: string;
  filterItems: string[] = [];
  isHomePage = false;
  isApp = false;
  isListView = false;

  constructor(
    private modalController: ModalController,
    private store: Store<rootReducer.State>,
    private navParams: NavParams,
    private router: Router,
    // private theInAppBrowser: InAppBrowser,
    private platformService: PlatformService,
    private modalsService: ModalsService,
  ) {
    this.isHomePage = this.navParams.get('isHomePage');
    this.isApp = this.platformService.isCordova();
  }

  async onClose() {
    await this.modalController.dismiss();
  }

  goToPage(page: string): void {
    this.router.navigate([`/${page}`]);
    this.onClose();
  }

  onSignOutClick(): void {
    this.store.dispatch(fromActions.AuthLogout());
    this.onClose();
  }

  async onHelpClick() {
    this.onClose();
    this.modalsService.showModal({ component: ModalHelpComponent, cssClass: 'modal-help' });
  }

  public async openTerms(): Promise<void> {
    const url = 'https://www.sonymusic.com/terms-and-conditions/';
    const target = '_system';
    await Browser.open({ url });
    // this.theInAppBrowser.create(url, target);
  }

  public async openPrivacy(): Promise<void> {
    const url = 'https://www.sonymusic.com/privacy-policy/';
    const target = '_system';
    // this.theInAppBrowser.create(url, target);
    await Browser.open({ url});
  }
}
